module.exports = __webpack_public_path__ + "media/country_flags/gb-sct-f4554338.png";